<template>
  <div id="short-course" ref="whole_page">
    <vx-card v-if="addShortCourseView" id="AddShortCourse" :title="cardTitle" class="w-full mb-6">
      <div class="short-course-content">
        <h5>{{`Selected Module: `}} <strong>{{moduleName}}</strong></h5>
        <div v-if="taskGroupName">
          <h5>{{`Selected Task Group: `}} <strong>{{taskGroupName}}</strong></h5>
        </div>
        <div v-if="outcomeName">
          <h5>{{`Selected Outcome: `}} <strong>{{outcomeName}}</strong></h5>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full">
            <div class="vx-col w-full mb-3">
              <label>Name</label>
              <vs-input autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Name" v-model="formData.name" />
              <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
            </div>

            <div class="vx-col w-full">
              <label>Description</label>
              <vs-textarea autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Description" v-model="formData.description" />
              <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
            </div>

            <div class="vx-row w-full">
              <div class="vx-col sm:w-1/2 w-full">
                <label>Hours</label>
                <vs-input autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Hours" v-model="formData.hours" />
                <span class="text-danger text-sm" v-show="errors.has('Hours')">{{ errors.first('Hours') }}</span>

              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <label>Price</label>
                <vs-input autocomplete="off" v-validate="'required'" onClick="this.select();" class="w-full"  name="Price" v-model="formData.price" />
                <span class="text-danger text-sm" v-show="errors.has('Price')">{{ errors.first('Price') }}</span>

              </div>
              <div class="vx-col mt-4 sm:w-1/2 w-full">
                <vs-checkbox v-model="formData.isAccredited">Accredited</vs-checkbox>
              </div>
            </div>
            <div class="vx-row w-full mt-3">
              <div class="vx-col w-full">
                <label>Keywords</label>
                <div class="keyword-list" >
                  <div class="total">
                    <vs-chips color="success" placeholder="Keywords" v-model="formData.keywordList">
                      <vs-chip
                        :key="chip"
                        @click="remove(chip)"
                        v-for="chip in formData.keywordList" color="success" closable>
                        {{ chip }}
                      </vs-chip>
                    </vs-chips>
                  </div>
                </div>
                <small class="mt-1" >enter to add keyword</small>
              </div>
            </div>
            <div v-if="formData.id" class="vx-row w-full mt-3">
              <div class="vx-col  w-full">
                <label>Share link:</label>
              </div>
              <div class="vx-col  w-full">
                <a :href="shareUrl">{{shareUrl}}</a>
              </div>
            </div>

          </div>

          <div class="vx-col sm:w-1/2 w-full">
            <div class="vx-col w-full">
              <label>Logo <small>(required)</small></label>
              <file-pond
                v-if="!formData.logoUrl"
                id="filepond"
                ref="Logopond"
                :server="uploadLocation"
                :name="'file'"
                label-idle="Drop logo here or <span class='filepond--label-action'>Browse</span>"
                :allow-multiple="false"
                accepted-file-types="image/*,"
                :instant-upload="true"
                allowPaste=false
                :allow-image-preview="false"
                @processfile="uploadComplete"
                @removefile="logoRemoved"
              />
              <vx-card class="logoCard w-full mb-2" v-if="formData.logoUrl" >
                <div class="vx-row">
                  <p style="align-self:center;" class="ml-2 product-name font-medium">{{uploadedFileName(formData.logoUrl)}}</p>
                  <vs-spacer></vs-spacer>
                  <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" style="float:right!important"  @click.stop="removeFileButton('logoUrl')"></vs-button>
                </div>
              </vx-card>
            </div>
            <div class="vx-col w-full">
              <label>Video</label>
              <file-pond
                v-if="!formData.videoUrl"
                id="videofilepond"
                ref="Videopond"
                :server="uploadLocation"
                :name="'file'"
                label-idle="Drop video here or <span class='filepond--label-action'>Browse</span>"
                :allow-multiple="false"
                accepted-file-types="video/*,"
                :instant-upload="true"
                allowPaste=false
                :allow-image-preview="false"
                @processfile="videoUploadComplete"
                @removefile="videoRemoved"
              />
              <vx-card class="logoCard w-full mb-2" v-if="formData.videoUrl" >
                <div class="vx-row">
                  <p style="align-self:center;" class="ml-2 product-name font-medium">{{uploadedVideoName(formData.videoUrl)}}</p>
                  <vs-spacer></vs-spacer>
                  <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" style="float:right!important"  @click.stop="removeFileButton('videoUrl')"></vs-button>
                </div>
              </vx-card>
            </div>

            <div class="vx-col w-full">
              <label>Document</label>
              <file-pond
                v-if="!formData.documentUrl"
                id="documentfilepond"
                ref="Documentpond"
                :server="uploadLocation"
                :name="'file'"
                label-idle="Drop document here or <span class='filepond--label-action'>Browse</span>"
                :allow-multiple="false"
                accepted-file-types="application/pdf,"
                :instant-upload="true"
                allowPaste=false
                :allow-image-preview="false"
                @processfile="documentUploadComplete"
                @removefile="documentRemoved"
              />
              <vx-card class="logoCard w-full mb-2" v-if="formData.documentUrl" >
                <div class="vx-row">
                  <p style="align-self:center;" class="ml-2 product-name font-medium">{{uploadedFileName(formData.documentUrl)}}</p>
                  <vs-spacer></vs-spacer>
                  <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" style="float:right!important"  @click.stop="removeFileButton('documentUrl')"></vs-button>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
        
        <div class="vx-row pb-3">
          
          
        </div>
        <div class="vx-row pb-3">
          
        </div>
      </div>
      <div class="flex buttonArea w-full justify">
        <vs-button color="success" v-if="!updateCourseView" @click="validateCourse('createShortCourse')" type="filled" >Save</vs-button>
        <vs-button color="success" v-if="updateCourseView" @click="validateCourse('updateShortCourse')" type="filled" >Update</vs-button>
        <vs-button class="ml-3" color="danger" v-if="updateCourseView" @click="deleteShortCourseValidation" type="filled" >Delete</vs-button>
        <vs-button color="warning" type="border" class="ml-3" @click="cancelAdd" >Cancel</vs-button>

      </div>
    </vx-card>
    <vx-card v-if="shortCourseListView && !addShortCourseView" id="ShortCourseList" ref="ShortCourseList" title="Short Course List" class="w-full mb-6">
      <div>
        <vs-button icon-pack="feather" icon="icon-plus" @click="goToAddCourse">Add</vs-button>
        <vs-table ref="premiumList" stripe class="mt-3 vs-con-loading__container" single pagination @selected="handleSelectedCourse" :max-items="tasksPerPage" search :data="shortCourseList">
          <div slot="header" class="vx-row flex flex-wrap-reverse items-center flex-grow">
        
            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 vx-col s:w-1/3 xs:w-full sm:w-full md:w-1/3 lg:w-1/4 xl:w-1/6">
              <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
                <span class="mr-2">{{ currentTaskPage * tasksPerPage - (tasksPerPage - 1) }} - {{ shortCourseList.length - currentTaskPage * tasksPerPage > 0 ? currentTaskPage * tasksPerPage : shortCourseList.length }} of {{ shortCourseList.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/> 
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="tasksPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="tasksPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        
          <template slot="thead">
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="hours">Hours</vs-th>
            <vs-th sort-key="price">Price</vs-th>
            <vs-th sort-key="isAccredited">Accredited</vs-th>
            <vs-th sort-key="miniShortCourse">Type</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :data="course" :key="indextr" v-for="(course, indextr) in data"> 
      
            <vs-td :data="data[indextr].name">
              {{ course.name }}
            </vs-td>

            <vs-td :data="data[indextr].hours">
              {{ course.hours }}
            </vs-td> 

            <vs-td :data="data[indextr].price">
              {{ `R ${course.price}` }}
            </vs-td> 

            <vs-td :data="data[indextr].isAccredited">
              <i :class="course.isAccredited ? 'icon feather icon-check' : 'icon feather icon-x'"></i>
            </vs-td> 

            <vs-td :data="data[indextr].miniShortCourse">
              <vs-chip :color="course.miniShortCourse || course.microShortCourse ? 'secondary' : 'primary'">{{ course.microShortCourse ? 'Micro Course' : course.miniShortCourse ? 'Mini Course' : 'Short Course' }}</vs-chip>
            </vs-td> 

            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
  import vueFilePond, {setOptions } from 'vue-filepond';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

  export default {
    components:{
      FilePond
    },
    data() {
      return {
        addShortCourseView:false,
        shortCourseListView:false,
        updateCourseView:false,
        moduleName:"",
        taskGroupName: "",
        outcomeName: "",
        formData:{
          id: 0,
          taskGroupId: 0,
          outcomeId: 0,
          name: "",
          description: "",
          hours: "",
          price: "",
          logoUrl: "",
          videoUrl: "",
          documentUrl: "",
          isAccredited: false,
          keywordList:[],
        },
        shortCourseList:[],
        tasksPerPage:10,
        currentTaskPage:1,
        shareUrl:"",
      }
    },
    watch: {
      
    },
    computed: {
      server(){
        return {
          url: 'https://content.digicampus.co.za/scripts/',
          process: {
            url: 'tue4VGmEsLhfsy43X8WBemZ5UnTzLDuD2.php',
          },
        };
      },
      uploadLocation:{
        get() {
          return this.$buildUrl("tempupload");
        }
      },
      cardTitle: function() {
        if (this.updateCourseView) {
          if (this.outcomeName) {
            return "Update Micro Course"
          } else if (this.taskGroupName) {
            return "Update Mini Course"
          } else {
            return "Update Short Course"
          }
        } else {
          if (this.outcomeName) {
            return "Add Micro Course"
          } else if (this.taskGroupName) {
            return "Add Mini Course"
          } else {
            return "Add Short Course"
          }
        }
      }
    },
    methods: {
      initValues(){
        this.formData.id = 0;
        this.formData.taskGroupId = 0;
        this.formData.outcomeId = 0;
        this.formData.name = "";
        this.formData.description = "";
        this.formData.hours = "";
        this.formData.price = "";
        this.formData.logoUrl = "";
        this.formData.videoUrl = "";
        this.formData.documentUrl = "";
        this.formData.isAccredited = false;
        this.moduleName = "";
        this.taskGroupName = "";
        this.outcomeName = "";
        this.shortCourseList = [];
        this.tasksPerPage = 10;
        this.currentTaskPage = 1;
        this.updateCourseView = false;
        this.formData.keywordList = [];
        this.errors.clear();
        this.shareUrl = "";
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      uploadComplete(error, file) {
        var response = JSON.parse(file.serverId);
        if(response.url)
          this.formData.logoUrl = response.url;
        this.clearFilepond("Logopond")
      },
      documentUploadComplete(error, file) {
        var response = JSON.parse(file.serverId);
        if(response.url)
          this.formData.documentUrl = response.url;
        this.clearFilepond("Documentpond")
      },
      videoUploadComplete(error, file) {
        if(file.serverId)
          this.formData.videoUrl = file.serverId;
        this.clearFilepond("videoUrl")
      },
      logoRemoved(error, file) {
        this.formData.logoUrl = null;
      },
      videoRemoved(error, file) {
        this.formData.videoUrl = null;
      },
      documentRemoved(error, file) {
        this.formData.documentUrl = null;
      },
      clearFilepond(reference){
        var self = this;
        if(this.$refs[reference]){
          self.$refs[reference].getFiles().forEach(element => {
            self.$refs[reference].removeFile(element);
          });
        }
      },
      uploadedFileName(name){
        if(name){
          var size = name.length;
          var firstIndex = name.split("_")[0].length +1;
          var file = name.substring(firstIndex,size);
          return file
        }
        else{
          return name
        }
      },
      uploadedVideoName(name){
        if(name){
          var size = name.length;
          var firstIndex = name.split("g/")[0].length +2;
          var file = name.substring(firstIndex,size);
          return file
        }
        else{
          return name
        }
      },
      removeFileButton(file){
        var self = this;
        self.formData[file] = "";
        self.$vs.notify({
          title:'Information',
          color: "warning",
          text: "File Removed",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash',
        });
      },
      cancelAdd(){
        this.addShortCourseView = false;
        this.shortCourseListView = true;
        this.initValues();
        this.getShortCourseList();
      },
      createShortCourse(){
        var self = this;
        self.showLoadingOnElement("whole_page",1,"corners");
        self.formData.id = self.$route.params.moduleData && self.$route.params.moduleData.id ? self.$route.params.moduleData.id : null;
        self.formData.taskGroupId = self.$route.params.taskGroupData && self.$route.params.taskGroupData.id ? self.$route.params.taskGroupData.id : null;
        self.formData.outcomeId = self.$route.params.outcomeData && self.$route.params.outcomeData.id ? self.$route.params.outcomeData.id : null;

        var onSuccess = response =>{
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Short Course Created",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash',
          });
          self.showCourseList();
        }
      
        var onFinally = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        self.$ajaxPost(self, `ShortCourse/Add` ,self.formData, onSuccess, onFinally);
      },
      getShortCourseList(){
        var self = this;
        self.showLoadingOnElement("whole_page",1,"corners");
        var onSuccess = response =>{
          self.shortCourseList = response.data;
        }
      
        var onFinally = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        self.$ajaxGet(self, "ShortCourse/ListShortCourses" , onSuccess, onFinally);
      },
      handleSelectedCourse(courseData){
        var self = this;
        self.moduleName = courseData.moduleName;
        self.taskGroupName = courseData.taskGroupName;
        self.outcomeName = courseData.outcomeName;
        
        self.updateCourseView = true;
        self.formData.id = courseData.id;
        self.formData.moduleId = courseData.moduleId;
        self.formData.taskGroupId = courseData.taskGroupId;
        self.formData.outcomeId = courseData.outcomeId;
        self.formData.name = courseData.name;
        self.formData.description = courseData.description;
        self.formData.hours = courseData.hours;
        self.formData.price = courseData.price;
        self.formData.logoUrl = courseData.logoUrl;
        self.formData.videoUrl = courseData.videoUrl;
        self.formData.documentUrl = courseData.documentUrl;
        self.formData.isAccredited = courseData.isAccredited;
        self.addShortCourseView = true;
        self.formData.keywordList = !courseData.keywordList ? [] : courseData.keywordList;

        self.getShareLink();

      },
      updateShortCourse(){
        var self = this;
        self.showLoadingOnElement("whole_page",1,"corners");

        var onSuccess = response =>{
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Short Course Updated",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check',
          });
          self.showCourseList();
        }
      
        var onFinally = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        self.$ajaxPost(self, "ShortCourse/Update" , self.formData , onSuccess, onFinally);
      },
      showCourseList(){
        var self = this;
        self.shortCourseListView = true;
        self.addShortCourseView = false;
        self.updateCourseView = false;
        self.getShortCourseList();
      },
      deleteShortCourse(){
        var self = this;
        self.showLoadingOnElement("whole_page",1,"corners");

        var onSuccess = response =>{
          self.$vs.notify({
            title:'Information',
            color: "danger",
            text: "Short Course Removed",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash',
          });
          self.showCourseList();
        }
      
        var onFinally = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        if (self.formData.taskGroupId) {
          self.$ajaxGet(self, `ShortCourse/Mini/Delete?shortcourseId=${self.formData.id}`, onSuccess, onFinally);
        } else {
          self.$ajaxGet(self, `ShortCourse/Delete?shortcourseId=${self.formData.id}`, onSuccess, onFinally);
        }
      },
      deleteShortCourseValidation(){
        var self = this;
        self.$swal({
          title: 'Are you sure you want to delete' + " " + '<strong>' + self.formData.name + '</strong>',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: `Cancel`,
          confirmButtonText: 'Yes Delete',
          confirmButtonColor: '#d33',
        }).then((result) => {
          if (result.isConfirmed) {
            self.deleteShortCourse();
          }
        });
      },
      addOrUpdateShortCourse(moduleId){
        var self = this;
        self.showLoadingOnElement("whole_page",1,"corners");

        var onSuccess = response =>{
          self.moduleName = self.$route.params.moduleData.name;
          self.addShortCourseView = true;
          if(response.data){
            self.updateCourseView = true;
            self.handleSelectedCourse(response.data);
          }
        }
      
        var onFinally = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        self.$ajaxGet(self, `ShortCourse/Validate?moduleId=${moduleId}` , onSuccess, onFinally);
      },
      addOrUpdateMiniShortCourse(moduleData, taskGroupData){
        var self = this;
        self.showLoadingOnElement("whole_page",1,"corners");

        var onSuccess = response =>{
          self.moduleName = moduleData.name;
          self.taskGroupName = taskGroupData.name;
          self.addShortCourseView = true;
          if(response.data){
            self.updateCourseView = true;
            self.handleSelectedCourse(response.data);
          }
        }
      
        var onFinally = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        self.$ajaxGet(self, `ShortCourse/Mini/Validate?moduleId=${moduleData.id}&taskgroupId=${taskGroupData.id}` , onSuccess, onFinally);
      },
      addOrUpdateMicroShortCourse(moduleData, taskGroupData, outcomeData){
        var self = this;
        self.showLoadingOnElement("whole_page",1,"corners");

        var onSuccess = response =>{
          self.moduleName = moduleData.name;
          self.taskGroupName = taskGroupData.name;
          self.outcomeName = outcomeData.name;
          self.addShortCourseView = true;
          if(response.data){
            self.updateCourseView = true;
            self.handleSelectedCourse(response.data);
          }
        }
      
        var onFinally = response =>{
          if(self.$refs.whole_page){
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }
      
        self.$ajaxGet(self, `ShortCourse/Micro/Validate?moduleId=${moduleData.id}&taskgroupId=${taskGroupData.id}&outcomeId=${outcomeData.id}` , onSuccess, onFinally);
      },
      validateCourse(functionName){
        var self = this;
        self.$validator.validateAll().then(result => {
          if(result){
            self[functionName]();
          }
          else{
            self.$vs.notify({
              title: "Attention",
              color: "warning",
              text:  self.$validator.errors.items[0].msg,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-info"
            });
          }
        });
      },
      goToAddCourse(){
        var self = this;
        self.$router.push({ name: 'AddShortCourse'});
      },
      remove(item) {
        this.formData.keywordList.splice(this.formData.keywordList.indexOf(item), 1);
      },
      getShareLink(){
        var self = this;
        var onSuccess = response =>{
          var type = this.formData.outcomeId || this.formData.taskGroupId  ? 3 : 2 ;
          this.shareUrl =  `${window.location.origin}/home?shortcourse=${response.data}&type=${type}`
        }
        self.$ajaxGetAnon(self, `Share/GetUrl/${this.formData.id}` , onSuccess);
      },
      //https://localhost:44323/home?shortcourse=M8xkGMNX7Rj&type=2
    },
    mounted() {
      var self = this;
      self.initValues();
      if(self.$route.params.outcomeData && self.$route.params.outcomeData.id){
        self.addOrUpdateMicroShortCourse(self.$route.params.moduleData, self.$route.params.taskGroupData, self.$route.params.outcomeData);
      } else if(self.$route.params.taskGroupData && self.$route.params.taskGroupData.id){
        self.addOrUpdateMiniShortCourse(self.$route.params.moduleData, self.$route.params.taskGroupData);
      } else if(self.$route.params.moduleData && self.$route.params.moduleData.id){
        self.addOrUpdateShortCourse(self.$route.params.moduleData.id);
      }
      else{
        self.shortCourseListView = true;
        self.getShortCourseList();
      }
    },
  }

</script>
<style lang="scss">
  #short-course{
    .buttonArea{
      justify-content: end;
    }
    .logoCard{
      .vx-card__body{
        padding: 0.5rem 1.5rem !important;
      }
    }
  }
</style>
